/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown> }} Free_Trial_Days_FeatureInputs */

const en_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-day free trial`)
};

const id_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uji coba gratis ${i?.trialDays}-hari`)
};

const ms_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-hari percubaan percuma`)
};

const ca_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prova gratuïta de ${i?.trialDays} dies`)
};

const cs_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}denní zkušební verze zdarma`)
};

const da_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratis prøveperiode på ${i?.trialDays} dage`)
};

const de_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-tägige kostenlose Testversion`)
};

const et_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-päevane tasuta prooviperiood`)
};

const es_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba gratis de ${i?.trialDays} días`)
};

const fr_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essai gratuit pendant ${i?.trialDays} jours`)
};

const hr_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dnevno besplatno probno razdoblje`)
};

const it_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prova gratuita di ${i?.trialDays} giorni`)
};

const lv_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} dienu bezmaksas izmēģinājuma periods`)
};

const lt_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nemokamas bandomasis laikotarpis ${i?.trialDays} d.`)
};

const hu_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-nap ingyenes próbaidőszak`)
};

const nl_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratis proefperiode van ${i?.trialDays} dagen`)
};

const nb_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dagers gratis prøveperiode`)
};

const pl_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dniowy bezpłatny okres próbny`)
};

const pt_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste gratuito de ${i?.trialDays} dias`)
};

const ro_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perioadă de probă de ${i?.trialDays} zile`)
};

const sk_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dňová bezplatná skúšobná verzia`)
};

const sl_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dnevni brezplačni preizkus`)
};

const fi_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} päivän ilmainen kokeilujakso`)
};

const sv_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-dagar gratis provperiod`)
};

const vi_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dùng thử miễn phí ${i?.trialDays} ngày`)
};

const tr_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} günlük ücretsiz deneme`)
};

const el_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} ημέρες δωρεάν δοκιμής`)
};

const bg_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-дневен безплатен пробен период`)
};

const ru_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}- дневная пробная версия`)
};

const sr_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} дан(а) бесплатне пробе`)
};

const uk_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-дня (-і) безкоштовної пробної версії`)
};

const ka_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-დღიანი უფასო საცდელი პერიოდი`)
};

const hi_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-दिन का फ्री ट्रायल`)
};

const th_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี ${i?.trialDays} วัน`)
};

const ko_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}일 무료 체험`)
};

const zh_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} 天免费试用`)
};

const zh_tw_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-天免費試用`)
};

const ja_free_trial_days_feature = /** @type {(inputs: Free_Trial_Days_FeatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays}-日間無料トライアル`)
};

/**
* | output |
* | --- |
* | "{trialDays}-day free trial" |
*
* @param {Free_Trial_Days_FeatureInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const free_trial_days_feature = /** @type {((inputs: Free_Trial_Days_FeatureInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Trial_Days_FeatureInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_free_trial_days_feature(inputs)
	if (locale === "ms") return ms_free_trial_days_feature(inputs)
	if (locale === "ca") return ca_free_trial_days_feature(inputs)
	if (locale === "cs") return cs_free_trial_days_feature(inputs)
	if (locale === "da") return da_free_trial_days_feature(inputs)
	if (locale === "de") return de_free_trial_days_feature(inputs)
	if (locale === "et") return et_free_trial_days_feature(inputs)
	if (locale === "es") return es_free_trial_days_feature(inputs)
	if (locale === "fr") return fr_free_trial_days_feature(inputs)
	if (locale === "hr") return hr_free_trial_days_feature(inputs)
	if (locale === "it") return it_free_trial_days_feature(inputs)
	if (locale === "lv") return lv_free_trial_days_feature(inputs)
	if (locale === "lt") return lt_free_trial_days_feature(inputs)
	if (locale === "hu") return hu_free_trial_days_feature(inputs)
	if (locale === "nl") return nl_free_trial_days_feature(inputs)
	if (locale === "nb") return nb_free_trial_days_feature(inputs)
	if (locale === "pl") return pl_free_trial_days_feature(inputs)
	if (locale === "pt") return pt_free_trial_days_feature(inputs)
	if (locale === "ro") return ro_free_trial_days_feature(inputs)
	if (locale === "sk") return sk_free_trial_days_feature(inputs)
	if (locale === "sl") return sl_free_trial_days_feature(inputs)
	if (locale === "fi") return fi_free_trial_days_feature(inputs)
	if (locale === "sv") return sv_free_trial_days_feature(inputs)
	if (locale === "vi") return vi_free_trial_days_feature(inputs)
	if (locale === "tr") return tr_free_trial_days_feature(inputs)
	if (locale === "el") return el_free_trial_days_feature(inputs)
	if (locale === "bg") return bg_free_trial_days_feature(inputs)
	if (locale === "ru") return ru_free_trial_days_feature(inputs)
	if (locale === "sr") return sr_free_trial_days_feature(inputs)
	if (locale === "uk") return uk_free_trial_days_feature(inputs)
	if (locale === "ka") return ka_free_trial_days_feature(inputs)
	if (locale === "hi") return hi_free_trial_days_feature(inputs)
	if (locale === "th") return th_free_trial_days_feature(inputs)
	if (locale === "ko") return ko_free_trial_days_feature(inputs)
	if (locale === "zh") return zh_free_trial_days_feature(inputs)
	if (locale === "zh-tw") return zh_tw_free_trial_days_feature(inputs)
	if (locale === "ja") return ja_free_trial_days_feature(inputs)
	return en_free_trial_days_feature(inputs)
});